// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__-mBiw","alternative":"Button_alternative__2U8oX"};